import React from 'react'
import { Checkbox } from 'antd'
import { ApiOutlined } from '@ant-design/icons'
import { useAppSelector } from '~/Store'
import { getRoleProductClaims } from '~/Store/Role/selectors'
import { IProduct } from '~/Services/Product.interface'

interface Props {
  product: IProduct
  selectedClaimIds: string[]
  onToggleProduct: (checked: boolean, allClaimIds: string[]) => void
}

export const RoleProductHeader = ({
  product,
  selectedClaimIds,
  onToggleProduct,
}: Props) => {
  const claims = useAppSelector(getRoleProductClaims(product.guid))

  const totalCount = claims?.length ?? 0
  const selectedCount = selectedClaimIds.length
  const checked = totalCount > 0 && selectedCount === totalCount
  const indeterminate = selectedCount > 0 && selectedCount < totalCount

  const handleChange = (evt: any) => {
    onToggleProduct(
      evt.target.checked,
      (claims || []).map(c => c.guid),
    )
  }

  return (
    <div
      style={{ display: 'flex', alignItems: 'center', flex: 1 }}
      onClick={evt => evt.stopPropagation()}
    >
      <Checkbox
        checked={checked}
        indeterminate={indeterminate}
        onChange={handleChange}
        style={{ marginRight: '10px' }}
      />
      <ApiOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
      <span style={{ fontWeight: 'bold', flex: 1 }}>{product.name}</span>
      {totalCount > 0 && (
        <span style={{ marginRight: '10px' }}>
          {selectedCount}/{totalCount}
        </span>
      )}
    </div>
  )
}
